module.exports = __webpack_public_path__ + "static/media/static-2.d0bb31ba.jpg";